import React, { Fragment } from 'react';
import { Alert, Card } from 'antd';
import InfoRow from '../../../../components/common/info-row';
import { SOURCE_ORDER } from '../../../../utils/const';
import { dateToString } from '../../../../utils';

export default ({ orderDetail }) => {


	return <Fragment>
		<Card title="Thông tin đơn hàng">
			{orderDetail.invoiceRefundId && <Alert className={'mb-10'} message={<><b>Đơn đổi hàng từ đơn trả <a
				onClick={() => window.open('/customer-refund/' + orderDetail.invoiceRefundId)}>{orderDetail.invoiceRefundCode}</a></b></>}
																						 type={'success'} />}
			<InfoRow labelSpan={8} valueSpan={16} value={'SurfaceCity'} label={'Bán tại'} />
			<InfoRow labelSpan={8} valueSpan={16} value={'---'} label={'Người bán'} />
			<InfoRow labelSpan={8} valueSpan={16}
							 value={SOURCE_ORDER.find(el => el.value === orderDetail.source)?.name || '---'} label={'Nguồn'} />
			<InfoRow labelSpan={8} valueSpan={16} value={dateToString(orderDetail.createdDate)} label={'Ngày bán'} />
			<InfoRow labelSpan={8} valueSpan={16} value={orderDetail.pathOrder} label={'Đường dẫn mua hàng'} />
			{/*<div style={{textAlign: 'center', marginTop: 15, paddingTop: '20px', fontSize: 12, fontWeight: 'bold', borderTop: '1px solid #eaeaea'}}>*/}
			{/*	<span style={{color: 'rgb(0, 136, 255)', cursor: 'pointer'}} onClick={() => {}}>*/}
			{/*		Xem lịch sử đơn hàng*/}
			{/*	</span>*/}
			{/*</div>*/}
		</Card>
	</Fragment>;
}
